import Entity from "../singleton/entity";

export default {

    getAll: Entity.getAll.bind(Entity),

    getAllRaw: Entity.getAllRaw.bind(Entity),

    getAllWithIcons: Entity.getAllWithIcons.bind(Entity),

    get: Entity.get.bind(Entity),

    create: Entity.create.bind(Entity),

    delete: Entity.delete.bind(Entity),

    toggleRestricted: Entity.toggleRestricted.bind(Entity),

    isRestricted: Entity.isRestricted.bind(Entity),

    getFields: Entity.getFields.bind(Entity),

    rename: Entity.rename.bind(Entity),

    getFieldsByType: Entity.getFieldsByType.bind(Entity),

    getRelatedFields: Entity.getRelatedFields.bind(Entity),

    hasAccess: Entity.hasAccess.bind(Entity),

    getFilteringCandidtes: Entity.getFilteringCandidtes.bind(Entity)

}